var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import AllhomesListingBadges from './allhomes-listing-badges';
import { jsx as ___EmotionJSX } from "@emotion/core";
var fragment = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment ListingBadges on Property {\n    listing {\n      annotations {\n        badge\n        label\n      }\n    }\n  }\n"])));
var AllhomesListingBadgesGraphQL = _ref => {
  var _property$listing;
  var property = _ref.property;
  return ___EmotionJSX(AllhomesListingBadges, {
    annotations: (_property$listing = property.listing) === null || _property$listing === void 0 ? void 0 : _property$listing.annotations
  });
};
AllhomesListingBadgesGraphQL.fragment = fragment;
AllhomesListingBadgesGraphQL.propTypes = {
  property: PropTypes.shape({
    listing: PropTypes.shape({
      annotations: PropTypes.arrayOf(PropTypes.shape({
        badge: PropTypes.string,
        label: PropTypes.string
      }))
    })
  })
};
AllhomesListingBadgesGraphQL.defaultProps = {
  property: {}
};
export default AllhomesListingBadgesGraphQL;